module.exports = __webpack_public_path__ + "media/img/payment-methods/mastercard-old-af8e60ca2675ef09dbbc89197956e18e.svg";